import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)
const home = () => import('@/views/home/index')
const indexpage = () => import('@/views/home/indexpage')
const homeIndex = () => import('@/views/home/home')
const about = () => import('@/views/home/about')
const service = () => import('@/views/home/service')
const solution = () => import('@/views/home/solution')
const client = () => import('@/views/home/client')
const details = () => import('@/views/home/details')
const contact = () => import('@/views/home/contact')
const advantage = () => import('@/views/home/wx/advantage')
const framework = () => import('@/views/home/wx/framework')
const profile = () => import('@/views/home/wx/profile')
const purpose = () => import('@/views/home/wx/purpose')
const resources = () => import('@/views/home/wx/resources')
const wxhome = () => import('@/views/home/wx/home')
const routes = [{
    path: '/',
    component: indexpage,
    redirect: '/home',
    children: [{
        path: '/home',
        component: home,
        redirect: '/homeIndex',
        children: [
            {
                path: '/homeIndex',
                component: homeIndex,
            },
            {
                path: '/about',
                component: about
            }, {
                path: '/service',
                component: service
            }, {
                path: '/solution',
                component: solution
            }, {
                path: '/client',
                component: client
            }, {
                path: '/details',
                component: details
            }, {
                path: '/contact',
                component: contact
            }
        ]
    },]
}, 
{
    path: '/wxhome',
    component: wxhome
},{
    path: '/advantage',
    component: advantage
}, {
    path: '/framework',
    component: framework
}, {
    path: '/profile',
    component: profile
}, {
    path: '/purpose',
    component: purpose
}, {
    path: '/client',
    component: client
}, {
    path: '/resources',
    component: resources
}
]

export default new VueRouter({
    routes
})


// WEBPACK FOOTER //
// ./src/router/index.js